module.exports = __webpack_public_path__ + "static/media/profile.59e0503b.jpg";